import React, { useState } from "react";
import { ArrowLeftlineIcon } from "../icon/ArrowLeftlineIcon";
import { ArrowRightlineIcon } from "../icon/ArrowRightlineIcon";

interface Props {
  images: string[];
}

export const ImageCarouselViewer: React.FC<Props> = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const isFirst = currentIndex === 0;
  const isLast = currentIndex === images.length - 1;

  const handlePrevious = () => {
    if (isFirst) {
      return;
    }

    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    if (isLast) {
      return;
    }

    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="flex flex-col w-[769px] rounded-[8px] overflow-hidden">
      {images.length > 0 ? (
        <div>
          <img
            src={images[currentIndex]}
            alt={`Image ${currentIndex + 1}`}
            className="w-full h-[427px] object-contain"
          />
          <div className="flex justify-center gap-[16px] mt-[24px]">
            <button
              onClick={handlePrevious}
              className={isFirst ? "cursor-default" : "cursor-pointer"}
            >
              <ArrowLeftlineIcon
                size={32}
                color={isFirst ? "text-gray-400" : "text-gray-900"}
              />
            </button>
            <button
              onClick={handleNext}
              className={isLast ? "cursor-default" : "cursor-pointer"}
            >
              <ArrowRightlineIcon
                size={32}
                color={isLast ? "text-gray-400" : "text-gray-900"}
              />
            </button>
          </div>
        </div>
      ) : (
        <img
          className="w-full h-[427px] "
          src="/img/empty-item-image.png"
        ></img>
      )}
    </div>
  );
};
